export const BASIC_DATA_DATE_FIELDS = [
  'date_incorporation',
  'dgi_issue_date',
  'dgi_expiration_date',
  'bps_issue_date',
  'bps_expiration_date',
] as const;

export const normalizeToIsoDate = (dateStr: string | undefined | null): string => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const trimmed = dateStr.trim();
  if (!trimmed || trimmed.includes('undefined')) return '';

  const isValidDateParts = (year: string, month: string, day: string): boolean => {
    const m = Number(month);
    const d = Number(day);
    return (
      year.length === 4 &&
      !isNaN(Number(year)) &&
      !isNaN(m) &&
      !isNaN(d) &&
      m >= 1 &&
      m <= 12 &&
      d >= 1 &&
      d <= 31
    );
  };

  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    if (!isValidDateParts(year, month, day)) return '';
    return `${year}-${month}-${day}`;
  }

  if (trimmed.includes('/')) {
    const parts = trimmed.split('/');
    if (parts.length === 3) {
      const [a, b, c] = parts;
      if (a.length === 4) {
        const [year, day, month] = [a, b, c];
        if (isValidDateParts(year, month, day)) {
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      }
      if (c.length === 4) {
        const [day, month, year] = [a, b, c];
        if (isValidDateParts(year, month, day)) {
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      }
      if (c.length === 2) {
        const [day, month, yy] = [a, b, c];
        const year = Number(yy) >= 70 ? `19${yy}` : `20${yy}`;
        if (isValidDateParts(year, month, day)) {
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      }
    }
  }

  return '';
};

export const normalizeBasicDataDatesForForm = <T extends object>(basicData: T): T => {
  const result = { ...basicData };
  for (const field of BASIC_DATA_DATE_FIELDS) {
    const value = result[field];
    if (typeof value === 'string' && value.trim()) {
      (result as Record<string, unknown>)[field] = normalizeToIsoDate(value);
    }
  }
  return result;
};

export const formatDateToISO = (dateStr: string | undefined): string => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const iso = normalizeToIsoDate(dateStr);
  if (iso) return iso;
  return '';
};
